import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50">麻豆影视</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              麻豆影视在线观看提供海量高清电影电视剧全集免费在线播放，即点即播无需下载，流畅不缓冲。每日更新最新热播内容，打造您的专属在线影院。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">影视分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门推荐</h4>
            <ul className="space-y-2">
              <li><Link to="/category/action" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">最新动作片</Link></li>
              <li><Link to="/category/scifi" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">科幻大片</Link></li>
              <li><Link to="/category/comedy" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">喜剧电影</Link></li>
              <li><Link to="/category/anime" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热门动漫</Link></li>
              <li><Link to="/category/tv-series" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">电视剧</Link></li>
              <li><Link to="/category/variety" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">综艺节目</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">版权声明</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">帮助中心</a></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 麻豆影视 madouys.com 版权所有。本站所有内容均来自互联网，仅供网友学习交流。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-500 hover:text-background-300 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-background-300 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-background-300 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}